export const colorizeSvg = (fillColor: string) => (svg) => {
  const path = svg.querySelector('path');
  if (path) {
    path.setAttribute('style', `fill: ${fillColor}`);
  }
  return svg;
};
